import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  DialogActions,
  CircularProgress,
  DialogTitle,
  Grid,
  TextField,
  DialogContent,
  Divider,
  Typography,
  Tooltip,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import Masonry from "react-masonry-css";

import PlusButton from "../../../assets/images/plus-button.svg";
import { Close, HelpOutline } from "@material-ui/icons";

import { designContestCollection } from "../../../components/firebase/DataProvider";
import {
  FieldValue,
  storage,
} from "../../../components/firebase/FirebaseProvider";

import { useSnackbar } from "notistack";

import { withStyles } from "@material-ui/core/styles";

import "../style.css";
import useStyles from "./style";
import ReactPixel from "react-facebook-pixel";


const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export default function SubmitDialog({
  designContest = {},
  isOpen = false,
  user,
  profile = {},
}) {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  
  const [scroll] = React.useState("paper");
  const [isSubmitting, setSubmitting] = useState(false);
  const [formData, setFormData] = React.useState({
    images: [],
    name: "",
    title: "",
    description: "",
    philosophy: "",
    profession: "",
    age: "",
    domisili: "",
  });
  const [imageTypes, setImageTypes] = useState([
    "Desain 1",
    "Desain 2",
    "Storytelling",
  ]);
  const [images, setImages] = useState([]);
  const [philosophy, setPhilosophy] = useState({});

  const [professions, setProfessions] = useState([
    "Belum Bekerja",
    "Ibu Rumah Tangga",
    "Pedagang",
    "Pengawai Negeri Sipil",
    "Pelajar / Mahasiswa",
  ]);

  function onImageChange(e) {
    try {
      const uploadImages = e.target.files;
      if (
        uploadImages.length + images.length >
        designContest.data.max_image_submitted
      ) {
        throw new Error(
          `Ups, upload ${designContest.data.max_image_submitted} file saja ya`
        );
      }

      for (let i = 0; i < uploadImages.length; i++) {
        const image = uploadImages[i];
        if (image.type.split("/")[0] !== "image") {
          throw new Error("Ups, hanya menerima file gambar ya");
        }

        if (image.size > 2000000) {
          throw new Error("Waduh, ukuran file tidak boleh lebih dari 2MB ya");
        }
      }

      setImages([...images, ...uploadImages]);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    }
  }

  function onFileChange(e) {
    try {
      if (e.target.files.length > 1) {
        throw new Error("Ups, upload 1 file saja ya");
      }

      const file = e.target.files[0];

      if (file.type !== "application/pdf") {
        throw new Error("Waduh, format file tidak didukung");
      }

      if (file.size > 5000000) {
        throw new Error("Waduh, ukuran file tidak boleh lebih dari 5MB ya");
      }

      setPhilosophy(file);

      setFormData({
        ...formData,
        philosophy: file.name,
      });
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
    }
  }

  const removeImage = (index) => {

    URL.revokeObjectURL(formData.images[index]);

    let newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const handleChange = (prop) => (e) => {
    setFormData({
      ...formData,
      [prop]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {

      if (!designContest?.data?.isSubmitable) {
        throw new Error("Tidak bisa submit desain sekarang");
      }

      setSubmitting(true);

      const {
        name,
        subdomain,
        avatar,
        title,
        description,
        age,
        profession,
        domisili,
        images: formImages,
        philosophy: formPhilosophy,
      } = formData;

      const umur = age.toString().replace(/\D/g, '');

      const {
        id,
        data: { max_design_submitted },
      } = designContest;

      if (
        !name ||
        !title ||
        !umur ||
        !profession ||
        !domisili
      ) {
        let fields = [];
        if (!name) {
          fields.push("Nama");
        }
        if (!title) {
          fields.push("Nama Koleksi");
        }
        if (!umur) {
          fields.push("Umur");
        }
        if (!profession) {
          fields.push("Profesi");
        }
        if (!domisili) {
          fields.push("Domisili");
        }
        throw new Error(`Mohon isi untuk kolom ${fields.join(", ")}`);
      }

      if (formImages.length !== designContest.data.max_image_submitted) {
        throw new Error(`Ups, mohon upload ${designContest.data.max_image_submitted} file ya`)
      }

      // if (!formPhilosophy) {
      //   throw new Error(
      //     "Mohon untuk menyisipkan Filosofi/Moodboard/Storyboard/Referensi Desain"
      //   );
      // }

      const user_id = user?.uid;

      const getDesignByUserId = await designContestCollection
        .doc(id)
        .collection("designs")
        .where("user_id", "==", user_id)
        .get();
      if (getDesignByUserId.docs.length >= max_design_submitted) {
        throw new Error(
          `Ups, hanya dapat mengirim desain sebanyak ${max_design_submitted} kali`
        );
      }

      try {
        const uploadFiles = async (files, designId) => {
          try {
            const result = await Promise.all(
              files.map(async (file, index) => {
                const now = Math.round(Date.now() / 1000);
                const ext = file.name.split(".").pop();
                const fileName = `file-${now}-${index}.${ext}`;

                await storage
                  .ref(`design_contest/${id}/${designId}/${fileName}`)
                  .put(file);

                const url = await storage
                  .ref(`design_contest/${id}/${designId}`)
                  .child(fileName)
                  .getDownloadURL();

                return url;
              })
            );

            formImages.forEach(item => {
              URL.revokeObjectURL(item)
            });

            return result;
          } catch (error) {
            console.log(error.message);
          }
        };

        const design = await designContestCollection
          .doc(id)
          .collection("designs")
          .add({});

        const designImages = await uploadFiles(images, design.id);
        // const designPhilosophy = formPhilosophy
        //   ? await uploadFiles([philosophy], design.id)
        //   : [""];

        await designContestCollection
          .doc(id)
          .collection("designs")
          .doc(design.id)
          .set(
            {
              user_id,
              images: designImages,
              // philosophy: designPhilosophy[0],
              status: "pending",
              upvotes: 0,
              likes: 0,
              title,
              description,
              owner_info: {
                avatar,
                name,
                subdomain,
                user_id,
                age: umur,
                profession,
                domisili
              },
              submitted_at: FieldValue.serverTimestamp(),
            },
            { merge: true }
          );
          ReactPixel.trackSingle("637526027426146","addToCart");
        enqueueSnackbar("Yeay, desain berhasil dikirimkan", {
          variant: "success",
        });

        setSubmitting(false);

        return history.push("/fashion-design-competition");
      } catch (error) {
        throw new Error(error.message);
      }
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      setSubmitting(false);
    }
  };

  useEffect(() => {
    // if (images.length < 1) return;
    const newImageUrls = [];
    images.forEach((image) => newImageUrls.push(URL.createObjectURL(image)));
    setFormData({ ...formData, images: newImageUrls });
  }, [images]);

  useEffect(() => {
    if (isOpen) {
      const unloadCallback = (event) => {
        event.preventDefault();
        event.returnValue = "";
        return "";
      };

      window.addEventListener("beforeunload", unloadCallback);
      return () => window.removeEventListener("beforeunload", unloadCallback);
    }
  }, [isOpen]);

  useEffect(() => {
    setFormData({
      ...formData,
      name: profile?.name,
      subdomain: profile?.subdomain,
      avatar: profile?.avatar,
    });
  }, [profile]);

  const breakpointColumnsObj = {
    default: 2,
    1100: formData.length > 0 ? 2 : 1,
    900: 1,
  };

  return (
    <>
      {user ? (
        <>
          <DialogTitle
            id="scroll-dialog-title"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                marginRight: "5px",
              }}
            >
              Upload desainmu di sini
            </span>
            <HtmlTooltip
              className={classes.help}
              placement="bottom-start"
              enterTouchDelay={0}
              title={
                <React.Fragment>
                  <Typography color="inherit">Ketentuan upload:</Typography>
                  <ul
                    style={{
                      marginLeft: "-25px",
                    }}
                  >
                    <li>
                      {
                        "Upload 3 gambar"
                      }
                      <ol
                        style={{
                          marginLeft: "-25px",
                        }}
                      >
                        <li>
                          {"Desain tunik atau gamis untuk wanita beserta info bahan,"}
                        </li>
                        <li>
                          {"Desain koko untuk pria beserta info bahan,"}
                        </li>
                        <li>
                          {"Storytelling atau inspirasi desain"}
                        </li>
                      </ol>
                    </li>
                    <li>{"Ukuran maksimal 2MB per gambar"}</li>
                  </ul>
                </React.Fragment>
              }
            >
              <span>
                <HelpOutline
                  style={{
                    width: "15px",
                  }}
                />
              </span>
            </HtmlTooltip>
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"} >
            <Grid container spacing={2}>
              <Grid item xs={12} md={8} className={classes.placeholder}>
                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="my-masonry-grid"
                  columnClassName="my-masonry-grid_column"
                >
                  <div className={classes.wrapper}>
                    <label
                      className={classes.upload_zone}
                      style={{
                        opacity: formData?.images?.length >= 3 ? 0.7 : 1,
                      }}
                      htmlFor="imageInput"
                    >
                      <input
                        type="file"
                        id="imageInput"
                        multiple
                        accept="image/*"
                        onChange={onImageChange}
                        hidden
                        disabled={formData?.images?.length >= 3 || isSubmitting}
                      />
                      <img
                        src={PlusButton}
                        alt="plus-button"
                        width="35px"
                        loading="lazy"
                      />
                      <span>Upload Gambar</span>
                    </label>
                  </div>

                  {formData?.images?.length > 0
                    ? formData?.images?.map((item, index) => {
                        return (
                          <div
                            className={classes.wrapper}
                            key={index}
                            style={{
                              border: "1px solid darkgrey",
                            }}
                          >
                            <div
                              style={{
                                // borderLeft: "1px solid darkgrey",
                                // borderRight: "1px solid darkgrey",
                                borderBottom: "1px solid darkgrey",
                              }}
                            >
                              <p
                                style={{
                                  margin: "5px",
                                  color: "grey",
                                }}
                              >
                                {imageTypes[index]}
                              </p>
                            </div>
                            <img
                              src={item}
                              alt={`gambar-${index + 1}`}
                              className={classes.images_preview}
                              loading="lazy"
                            />

                            <span onClick={() => removeImage(index)}>
                              <Close className={classes.close_button} />
                            </span>
                          </div>
                        );
                      })
                    : ""}
                </Masonry>
              </Grid>
              <Grid item xs={12} md={4}>
                <form>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Nama koleksi
                  </Typography>
                  <Grid
                    container
                    spacing={2}
                    style={{
                      marginTop: "10px",
                    }}
                  >
                    <Grid item xs={12}>
                      <TextField
                        id="title"
                        label="Contoh: Muscary, Alamanda"
                        variant="outlined"
                        fullWidth
                        required
                        onChange={handleChange("title")}
                        value={formData?.title}
                        disabled={isSubmitting}
                        inputProps={{
                          maxLength: 50
                        }}
                      />
                    </Grid>
                  </Grid>
                  {/* <Grid
                    container
                    spacing={2}
                    style={{
                      marginBottom: "20px",
                    }}
                  >
                    <Grid item xs={12}>
                      <input
                        accept="application/pdf"
                        className={classes.input}
                        id="contained-button-file"
                        multiple
                        type="file"
                        hidden
                        onChange={onFileChange}
                        disabled={isSubmitting}
                      />
                      <p
                        style={{
                          marginTop: "0",
                          marginBottom: "10px",
                          color: "grey",
                        }}
                      >
                        Filosofi/Moodboard/Cerita di balik Desain
                      </p>
                      <label
                        htmlFor="contained-button-file"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          component="span"
                        >
                          Upload
                        </Button>
                      </label>
                      <p
                        style={{
                          textAlign: "center",
                          margin: "5px",
                        }}
                      >
                        {formData.philosophy ? formData.philosophy : ""}
                      </p>
                    </Grid>
                  </Grid> */}

                  <Divider
                    style={{
                      marginBottom: "20px",
                    }}
                  />

                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: "bold",
                      marginBottom: "15px",
                    }}
                  >
                    Profil Desainer
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        id="nama"
                        label="Nama Desainer"
                        variant="outlined"
                        fullWidth
                        required
                        onChange={handleChange("name")}
                        value={formData?.name}
                        disabled={isSubmitting}
                        inputProps={{
                          maxLength: 50
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={6} xs={12}>
                      <TextField
                        id="umur"
                        label="Umur"
                        variant="outlined"
                        fullWidth
                        required
                        onChange={handleChange("age")}
                        value={formData?.age}
                        disabled={isSubmitting}
                        inputProps={{
                          maxLength: 3
                        }}
                      />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      <Autocomplete
                        freeSolo
                        id="profesi"
                        variant="outlined"
                        fullWidth
                        onChange={(e, v) => {
                          handleChange("profession")({
                            target: {
                              value: v,
                            },
                          });
                        }}
                        value={formData?.profession}
                        disabled={isSubmitting}
                        options={professions.map(
                          (option) => option
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Profesi"
                            variant="outlined"
                            onChange={handleChange("profession")}
                            required
                          />
                        )}
                        getOptionLabel={(option) => option || ""}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        id="domisili"
                        label="Domisili"
                        variant="outlined"
                        multiline
                        minRows={5}
                        fullWidth
                        required
                        onChange={handleChange("domisili")}
                        value={formData?.domisili}
                        disabled={isSubmitting}
                        inputProps={{
                          maxLength: 200
                        }}
                      />
                    </Grid>
                  </Grid>
                </form>
              </Grid>              
            </Grid>
          </DialogContent>
          <DialogActions
            style={{
              marginRight: "15px",
            }}
          >
            <Button
              onClick={() => {
                if (
                  window.confirm(
                    "Apakah anda yakin ingin menutup form ini? informasi yang anda masukkan akan hilang."
                  )
                ) {
                  return history.goBack();
                }
              }}
              className={classes.submitButton}
              variant="outlined"
              style={{
                color: "#CF000F",
                backgroundColor: "#FFF",
                border: "1px solid #CF000F",
              }}
              disabled={isSubmitting}
            >
              Batalkan
            </Button>
            <Button
              className={classes.submitButton}
              color="primary"
              variant="contained"
              style={{
                minWidth: "132px",
              }}
              disabled={isSubmitting || !designContest?.data?.isSubmitable}
              onClick={handleSubmit}
            >
              {isSubmitting ? <CircularProgress size={24} /> : "Kirim Desain"}
            </Button>
          </DialogActions>
        </>
      ) : (
        "Please Login"
      )}
    </>
  );
}
